import { TrackingModal } from "./TrackingModal";
import { useDispatch } from "react-redux";
import Order from "@/redux/models/Order";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { DotsVerticalIcon } from "@heroicons/react/outline";
import { PopoverBase } from "@/components/Popover";
import { AddToCartButton } from "./AddToCartButton";

export const OrderActions = ({ order }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [trackingModalOpen, setTrackingModalOpen] = useState();

  const handleCompleteOrder = async (orderId) => {
    dispatch(
      Order.types.retrieveOrder({
        orderId,
        cb: () => router.push(`/checkout/${orderId}`),
        onRedirect: (redirectUrl) => router.push(redirectUrl),
      })
    );
  };

  const handleOrderConfirmation = (orderId) => {
    router.push(`/order/confirmation/${orderId}`);
  };

  const renderButton = () => (
    <div className="white-button px-2">
      <DotsVerticalIcon className="h-5 w-5 text-gray-500" />
    </div>
  );

  return (
    <>
      <div className="flex items-center justify-end pr-2 lg:relative absolute top-2 lg:top-0 right-0">
        <PopoverBase button={renderButton()}>
          <div className="flex flex-col w-[170px] bg-white shadow-lg border-2 rounded-sm ml-[-3]">
            {order.status === "shipped" && (
              <button
                onClick={() => setTrackingModalOpen(order)}
                className="text-xs py-2 outline-gray-400 hover:bg-gray-100"
              >
                Tracking
              </button>
            )}
            {order.is_completed && <AddToCartButton order={order} />}
            {!order.is_completed && (
              <button
                className="text-xs py-2 outline-gray-400 hover:bg-gray-100"
                type="button"
                onClick={() => handleCompleteOrder(order?.id)}
              >
                Buy Now
              </button>
            )}

            {order.is_completed && (
              <button
                onClick={() => handleOrderConfirmation(order?.id)}
                className="text-xs py-2 outline-gray-400 hover:bg-gray-100"
              >
                Order Confirmation
              </button>
            )}
          </div>
        </PopoverBase>
      </div>
      <TrackingModal order={trackingModalOpen} onClose={() => setTrackingModalOpen()} />
    </>
  );
};
